<template>
  <div
    @click="darkMode.toggleDarkMode()"
    class="flex items-center gap-2 cursor-pointer p-2 rounded-lg active:scale-95 transition-all duration-200"
  >
    <Icon
      :icon="icon"
      :size="componentConfig.sizes.LG"
    />
    <p v-if="showText">{{ darkMode.isDarkMode ? 'Dark' : 'Light' }}</p>
  </div>
</template>
<script>
  import Icon from '@/components/Shared/Icon.vue';
  import Tooltip from '@/components/Shared/Tooltip.vue';
  import useComponentConfig from '@/composables/useComponentConfig';
  import { useDarkMode } from '@/stores/useDarkMode.js';

  export default {
    name: 'ThemeSwitcher',
    components: { Tooltip, Icon },
    props: {
      showText: {
        type: Boolean,
        default: false
      }
    },
    data() {
      return {
        darkMode: useDarkMode(),
        componentConfig: useComponentConfig()
      };
    },
    computed: {
      icon() {
        return this.darkMode.isDarkMode ? 'pi pi-sun' : 'pi pi-moon';
      }
    }
  };
</script>
